/* eslint-disable react/require-default-props */
/* eslint-disable no-unused-vars */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useRef } from 'react';
import BootstrapTable, { ColumnFormatter, ExpandRowProps } from 'react-bootstrap-table-next';
import filterFactory from 'react-bootstrap-table2-filter';
import paginationFactory from 'react-bootstrap-table2-paginator';
// @ts-ignore
import ToolkitProvider, { ToolkitContextType } from 'react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit';
import { useNavigate } from 'react-router-dom';
import { getCreateActionClassName, transformToBootstrapColumns } from '../../helpers/table';
import useTable from '../../hooks/table/useTable';
import { IBootstrapColumn } from '../../types/components/table/column-filter';
import { ITableColumn, ITableLayout } from '../../types/layout/table';
import Loader from '../loader';
import Modal, { IModalRefs } from '../modal';
import { ColumnActionDelete } from './column-actions';
import TableColumnsSelector from './columns-selector';
import TableSizePerPage from './per-page-size';
import TableSearch from './search';
import { useWindowSize } from '../../hooks/ui/useWindowSize';

function Table(props: React.PropsWithChildren<ITableLayout>) {
    const {
        actions, allowSearch, columns, columnsSelector, fullPageSize, cardClassName, header,
        height, primaryKey, title, showPagination, collapsable, collapsed: prdefinedCollapsed,
        rowClasses,
    } = props;

    const {
        columns: tableColumns, data, dataLoading, onColumnsSelectorChange,
        onTableChange, totalCount, rowDelete, insideForm, collapsed,
        onCollapseClick, getData, idOwner, tableName, tableParams, summary,
    } = useTable(props);

    const navigate = useNavigate();

    const modal = useRef<IModalRefs>();

    const windowSize = useWindowSize();

    const noDataIndication = () => 'Список пуст';

    const onCreateClick = () => {
        if (actions?.create) {
            if (typeof actions?.create === 'string') {
                navigate(actions.create);
            } else if (typeof actions.create === 'object') {
                if (actions.create.type === 'modal') {
                    modal.current?.show(actions.create.layoutLink, null, idOwner);
                }
            }
        }
    };

    const onRowClick = (_: any, row: Record<string, any>) => {
        if (actions && actions.edit) {
            if (typeof row.canEdit === 'undefined' || row.canEdit) {
                if (typeof actions.edit === 'object') {
                    if (actions.edit.type === 'modal') {
                        modal.current?.show(actions.edit.layoutLink, row[primaryKey], idOwner);
                    }
                }
            }
        }
    };

    const bootstrapColumns = transformToBootstrapColumns(props, windowSize, tableName);
    const hiddenBreakpointColumns = bootstrapColumns.filter((el) => el.hiddenBreakpointColumn);

    const modalActionFormatter = (row: Record<string, any>, column: ITableColumn) => (
        <div
            dangerouslySetInnerHTML={{ __html: column.content || column.title }}
            onClick={() => (column.action?.layoutLink ? modal.current?.show(column.action.layoutLink, row[primaryKey], idOwner) : undefined)}
        />
    );

    const updateActionColumns = (x: IBootstrapColumn[]) => x.map((el) => {
        const original = tableColumns.find((orig) => orig.dataIndex === el.dataField);
        if (original?.action?.type === 'modal') {
            return {
                ...el,
                formatter: (_: any, row: any) => modalActionFormatter(row, original),
            };
        }
        return el;
    });

    const deleteActionFormatter: ColumnFormatter<any> = (_, row) => (
        <ColumnActionDelete onClick={() => rowDelete(row)} />
    );

    const expandRowRenderer = (row: any) => (
        <ul className="list-group list-group-flush">
            {hiddenBreakpointColumns.map((el) => (
                <li className="list-group-item" key={el.dataField}>
                    <b>{el.text}</b>
                    {' '}
                    <div dangerouslySetInnerHTML={{ __html: row[el.dataField] }} />
                </li>
            ))}
        </ul>
    );

    const expandColumnRenderer: ExpandRowProps<any, any>['expandColumnRenderer'] = ({ expanded }) => (expanded
        ? (
            <div className="rounded-circle bg-danger table-row-expand-button">
                <i className="fas fa-minus" />
            </div>
        ) : (
            <div className="rounded-circle bg-info table-row-expand-button">
                <i className="fas fa-plus" />
            </div>
        ));

    const expandHeaderColumnRenderer = () => (
        <span />
    );

    const summaryRender = () => (Array.isArray(summary) && summary.length > 0 ? summary.map((el) => (
        <>
            <span>
                <b>{`${el.title}:`}</b>
                {` ${el.value}`}
            </span>
            <br />
        </>
    )) : null);

    const paginationTotalRenderer = (from: number, to: number, size: number) => (size > 0 ? (
        <div className="d-inline-block ml-2 pagination-total">
            {summaryRender()}
            <span>{`Показаны строки с ${from} по ${to} из ${size}.`}</span>
        </div>
    ) : <span />);

    const expandRow: ExpandRowProps<any, any> | undefined = (hiddenBreakpointColumns.length ? {
        renderer: expandRowRenderer,
        showExpandColumn: true,
        expandByColumnOnly: true,
        expandColumnRenderer,
        expandHeaderColumnRenderer,
    } : undefined);

    if (actions) {
        if (typeof actions.delete === 'string') {
            bootstrapColumns.push({
                dataField: 'action-delete',
                text: '',
                style: {
                    width: 50,
                    textAlign: 'center',
                },
                headerStyle: {
                    width: 50,
                },
                formatter: deleteActionFormatter,
            });
        }
    }

    const classes = ['card card-outline layout-item table-container'];

    if (typeof cardClassName === 'string') {
        classes.push(cardClassName);
    }

    if (fullPageSize) {
        classes.push('table-container-full-page');
    }

    if (!insideForm) {
        classes.push('mb-0');
    }

    if (prdefinedCollapsed) {
        classes.push('collapsed-card');
    }

    const content = (toolkitProps: ToolkitContextType) => (
        <div className={`card-body${fullPageSize ? ' d-flex flex-column' : ''}`}>
            {(columnsSelector || allowSearch) && (
                <div className="row p-2">
                    {columnsSelector && (
                        <TableColumnsSelector allColumns={columns} onChange={onColumnsSelectorChange} tableColumns={tableColumns} />
                    )}
                    {allowSearch && (
                        <TableSearch {...toolkitProps.searchProps} />
                    )}
                </div>
            )}
            <Loader loading={dataLoading} title="Загрузка данных" />
            {tableColumns.length > 0 && (
                <>
                    <BootstrapTable
                        {...toolkitProps.baseProps}
                        classes="mb-0"
                        columns={bootstrapColumns}
                        data={[]}
                        keyField={primaryKey}
                        filter={filterFactory()}
                        bordered={false}
                        remote={{
                            filter: true,
                            sort: true,
                        }}
                        onTableChange={onTableChange}
                        sort={tableParams.sortColumn && tableParams.sortOrder ? { dataField: tableParams.sortColumn, order: tableParams.sortOrder } : undefined}
                        expandRow={expandRow}
                    />
                    <BootstrapTable
                        {...toolkitProps.baseProps}
                        bordered={false}
                        classes="mb-0"
                        headerClasses="d-none"
                        wrapperClasses={`table-body-with-scroll ${tableName}`}
                        remote={{
                            filter: true,
                            pagination: true,
                            search: true,
                            sort: true,
                        }}
                        onTableChange={onTableChange}
                        filter={filterFactory()}
                        pagination={typeof showPagination === 'undefined' || showPagination ? paginationFactory({
                            totalSize: totalCount,
                            showTotal: true,
                            sizePerPageList: [10, 20, 30, 40, 50, 100],
                            sizePerPage: tableParams.sizePerPage,
                            sizePerPageRenderer: TableSizePerPage,
                            page: tableParams.page,
                            paginationTotalRenderer,
                        }) : null}
                        noDataIndication={noDataIndication}
                        rowEvents={{
                            onClick: onRowClick,
                        }}
                        hover
                        expandRow={expandRow}
                        rowClasses={rowClasses}
                    />
                </>
            )}
        </div>
    );

    return (
        <div key={hiddenBreakpointColumns.length ? 2 : 1} className={classes.join(' ')} style={{ maxHeight: height }}>
            {(actions?.create || collapsable || typeof header === 'string') && (
                <div className="card-header d-flex flex-grow-1 align-items-center w-100" hidden={typeof title === 'undefined'}>
                    {typeof title === 'string' && (
                        <h3 className="card-title">
                            {`${title} ${typeof totalCount === 'number' ? `(${totalCount})` : ''}`}
                        </h3>
                    )}
                    {typeof header === 'string' && (
                        <div className={typeof title === 'string' ? 'd-inline ml-2' : 'd-inline'} dangerouslySetInnerHTML={{ __html: header }} />
                    )}
                    <div className="card-tools d-flex flex-grow-1 justify-content-between ml-2">
                        <div className="d-flex flex-1">
                            {actions?.create && (
                                <button type="button" className={getCreateActionClassName(actions.create)} onClick={onCreateClick}>
                                    <span>Добавить</span>
                                </button>
                            )}
                        </div>
                        <button
                            type="button"
                            className="btn btn-tool"
                            data-card-widget="collapse"
                            hidden={!collapsable}
                            onClick={onCollapseClick}
                        >
                            <i className={['fas', collapsed ? 'fa-plus' : 'fa-minus'].join(' ')} />
                        </button>
                    </div>
                </div>
            )}
            <ToolkitProvider
                columns={updateActionColumns(bootstrapColumns)}
                data={dataLoading ? [] : data || []}
                keyField={primaryKey}
                search={{
                    defaultSearch: tableParams.search,
                }}
            >
                {content}
            </ToolkitProvider>
            {actions?.edit instanceof Object && actions.edit.type === 'modal' && (
                <Modal ref={modal} idOwner={idOwner} onHide={getData} />
            )}
        </div>
    );
}

export default Table;
